import { createContext } from 'react'
import { ConsentState, initialState } from '@reducers/ConsentReducer'

export interface ConsentContextProps extends ConsentState {
  toggleMajor(): void
  toggleConditions(): void
  toggleAutoFill(): void
  toggleReadConsent(): void
  sendConsents(surveyId: string): Promise<void>
  checkConsents(): Promise<void>
}

export const initialConsentContext: ConsentContextProps = {
  ...initialState,
  sendConsents: () => new Promise(() => {}),
  checkConsents: () => new Promise(() => {}),
  toggleMajor: () => {},
  toggleConditions: () => {},
  toggleAutoFill: () => {},
  toggleReadConsent: () => {},
}

export const ConsentContext = createContext<ConsentContextProps>(initialConsentContext)
